import { getCachedTrending } from "./cache";
import { SECTIONS } from "../../constants/sections";
import { MODE_CAML } from "./constants";

/**
 * @param {Function<Sections, number, Promise<Array|Map>>} fetchTrendingFromApi
 * @return {object} trending interface wrapping given api implementation
 */
export default function TrendingFactory(fetchTrendingFromApi) {
    /**
     * @param {string} siteSection
     * @param {Map<string, object>} [config]
     * @return {boolean}
     */
    const hasTrending = (siteSection) => {
        return (
            SECTIONS.hasOwnProperty(siteSection) &&
            SECTIONS[siteSection].hasOwnProperty("trending") ===
                !!SECTIONS[siteSection].trending
        );
    };

    const usingCaML = (siteSection) => {
        return (
            SECTIONS.hasOwnProperty(siteSection) &&
            SECTIONS[siteSection].hasOwnProperty("usingCaMLTrending") &&
            SECTIONS[siteSection].usingCaMLTrending
        );
    };

    /**
     * @param {string} siteSection name
     * @return {string} trending lineup slug
     */
    const getTrendingSection = (siteSection) => {
        let def = SECTIONS[siteSection] || {};
        return def.trendingSection || siteSection;
    };

    /**
     * @param {string} section trending section name
     * @param {number} numItems expected items per section
     * @return {Promise<Array<Object>>}
     */
    const getSection = (section, numItems) => {
        if (typeof section !== "string") {
            throw new Error("expected section to be type string");
        }

        if (typeof numItems !== "number") {
            throw new Error("expected numItems to be type number");
        }

        let now = Date.now();
        const mode = usingCaML(section) ? MODE_CAML : null;

        return getCachedTrending(section, numItems, now, mode).then(
            (maybeCached) => {
                if (maybeCached) {
                    return maybeCached;
                } else {
                    return fetchTrendingFromApi(section, numItems, mode);
                }
            }
        );
    };

    return {
        hasTrending,
        getTrendingSection,
        getSection,
        usingCaML,
    };
}
